import apiHelper from '../helpers/apiHelper'

export default {
  send(data)
  {
    return apiHelper.request('https://marketing.getincome.com/form/submit?formId=3', data, 'POST')
  }
}
